import { TypeOf, yup } from '@guiker/yup-util'

export const findOnePropertyOwnershipByPropertyId = yup
  .object({
    propertyId: yup.string().required(),
  })
  .required()

export type FindOnePropertyOwnershipByPropertyId = TypeOf<typeof findOnePropertyOwnershipByPropertyId>
